import { getTypographyMetric, getTypographyMetricOverride } from '../../helpers';
import { useTheme } from 'styled-components';
import { Typography } from 'hype-ds';
import { Flex } from 'front-commons/ds/components/Flex';
import { Button } from 'front-commons/ds/components/Button';
import { OrderImportButtonProps } from './interfaces';

export function OrderImportButton({ variant = 'DEFAULT', visible, onClick }: OrderImportButtonProps) {
	const { fontSizes } = useTheme();

	if (!visible) return null;

	return (
		<Flex
			as={Button}
			display={{ small: 'none', large: 'flex' }}
			gap="0"
			alignItems="center"
			justifyContent="center"
			position="relative"
			noShrink={true}
			borderRadius="8px"
			minHeight="40px"
			raw={{
				'&&': {
					borderRadius: '8px',
					gap: '0.25rem',
					"&[data-variant='none']": { padding: '0.25rem 0.5rem' },
					'&:hover': { backgroundColor: 'var(--surface-accent-light)', 'i, p': { color: 'var(--text-link)' } },
					p: {
						display: 'inline',
						fontWeight: '600',
						color: `var(${variant === 'DEFAULT' ? '--text-link' : '--greys-50'})`,
					},
				},
				"[data-header-text='OrderImportButton-metric-1']": {
					fontSize: getTypographyMetricOverride(fontSizes['16']),
					lineHeight: getTypographyMetricOverride(fontSizes['24']),
				},
			}}
			data-testid="order-import-button"
			onClick={onClick}
			leftIcon={{
				color: variant === 'DEFAULT' ? '--text-link' : '--greys-50',
				fill: true,
				name: 'upload_file',
				size: '16px',
			}}
			variant="none"
			width="188px"
		>
			<Typography
				data-header-text="OrderImportButton-metric-1"
				textAlign="inherit"
				fontSize={getTypographyMetric(fontSizes['16'])}
				fontWeight="600"
				lineHeight={getTypographyMetric(fontSizes['24'])}
			>
				Importação de pedido
			</Typography>
		</Flex>
	);
}
